export class FileUploadOptions {
    hasBaseDropZoneOver?: boolean = false;
    hasAnotherDropZoneOver?: boolean = false;
    url?: string = "";
    authToken?: string = "";
    itemAlias?: string = "";
}